// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2ipDu","row":"ProcedureTreatmentSummary_row__2L_1i"};